"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TitleActions =
/*#__PURE__*/
function () {
  function TitleActions(_ref) {
    var bus = _ref.bus,
        context = _ref.context;

    _classCallCheck(this, TitleActions);

    this.bus = bus;
    this.context = {
      room: undefined,
      collectionDefinition: undefined
    };

    _.extend(this.context, context);
  }

  _createClass(TitleActions, [{
    key: "perform",
    value: function perform(action, titleModel) {
      if (typeof this["_".concat(action)] === 'function') {
        this["_".concat(action)](titleModel);
      }
    }
  }, {
    key: "_borrow",
    value: function _borrow(titleModel) {
      this.bus.trigger('title:borrow', titleModel, this.context);
    }
  }, {
    key: "_hold",
    value: function _hold(titleModel) {
      this.bus.trigger('title:hold', titleModel, this.context);
    }
  }, {
    key: "_wish",
    value: function _wish(titleModel) {
      this.bus.trigger('title:wishlist', titleModel, this.context);
    }
  }, {
    key: "_recommend",
    value: function _recommend(titleModel) {
      this.bus.trigger('title:recommend', titleModel, this.context);
    }
  }, {
    key: "_nook",
    value: function _nook(titleModel) {
      this.bus.trigger('title:nook', titleModel, this.context);
    }
  }, {
    key: "_rating",
    value: function _rating(titleModel) {
      this.bus.trigger('title:rating', titleModel, this.context);
    }
  }, {
    key: "_history",
    value: function _history(titleModel) {
      this.bus.trigger('title:history', titleModel, this.context);
    }
  }, {
    key: "_download",
    value: function _download(titleModel) {
      this.bus.trigger('title:download', titleModel, this.context);
    }
  }, {
    key: "_preview",
    value: function _preview(titleModel) {
      this.bus.trigger('title:preview', titleModel, this.context);
    }
  }, {
    key: "_renew",
    value: function _renew(titleModel) {
      this.bus.trigger('title:renew', titleModel, this.context);
    }
  }, {
    key: "_requestAgain",
    value: function _requestAgain(titleModel) {
      this.bus.trigger('title:requestAgain', titleModel, this.context);
    }
  }, {
    key: "setContextRoom",
    value: function setContextRoom(room) {
      if (_(room).isEmpty()) {
        delete this.context.room;
      } else {
        this.context.room = room;
      }

      return this;
    }
  }, {
    key: "setContextCollection",
    value: function setContextCollection(titleCollection) {
      if (_(titleCollection).isEmpty()) {
        delete this.context.titleCollection;
      } else {
        this.context.titleCollection = titleCollection;
      }

      return this;
    }
  }]);

  return TitleActions;
}();

exports["default"] = TitleActions;